import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const InvoiceNotGlCodedRule = (props) => {
  const {
    form, onSubmit, initialValues, ...other
  } = props;
  const [numberDays, setNumberDays] = useState(initialValues.number_days || 5);
  const [regions, setRegions] = useState(
    !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  );

  const submit = useCallback((event) => {
    event.preventDefault();
    onSubmit({
      kind: 'invoice_not_glcoded',
      regions: _.filter(regions),
      value: {
        number_days: numberDays
      }
    });
  }, [numberDays, onSubmit, regions]);

  const onReset = useCallback(() => {
    setNumberDays(initialValues.number_days || 5);
    setRegions(
      !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
    );
  }, [initialValues.number_days, initialValues.regions]);


  return (
    <RuleForm
      {...other}
      onSubmit={submit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        value={regions}
        onChange={setRegions}
      />
      <InlineInputNumber
        label='Number of Days Ago'
        description='Only consider invoices dated at or before this period'
        value={numberDays}
        onChange={setNumberDays}
      />
    </RuleForm>
  );
};

InvoiceNotGlCodedRule.defaultProps = {
  initialValues: {}
};

InvoiceNotGlCodedRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
};

export default InvoiceNotGlCodedRule;
